import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { CueHistoryReviewFilter, CueMessagePayload, CueMessageState } from 'src/app/models/fincas/cue.model';
import { CueStatusPresenter } from './presenters/cue-status.presenter';
import { CueExportFlowFacade } from './services/cue-export-flow.facade';

/** Container component for the CUE export assistant. */
@Component({
  selector: 'app-finca-cue-dialog',
  standalone: false,
  templateUrl: './finca-cue-dialog.component.html',
  styleUrls: ['./finca-cue-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CueExportFlowFacade],
})
export class FincaCueDialogComponent implements OnChanges {
  @Input()
  public visible = false;

  @Input()
  public finca: FincasModel | null = null;

  @Output()
  public readonly visibleChange = new EventEmitter<boolean>();

  @Output()
  public readonly refreshRequested = new EventEmitter<void>();

  public readonly CUE_DIALOG_BREAKPOINTS: Readonly<Record<string, string>> = {
    '1199px': '70vw',
    '768px': '88vw',
    '575px': '96vw'
  };

  public historyReviewFilter: CueHistoryReviewFilter = 'all';

  private readonly emitRefreshRequested = (): void => {
    this.refreshRequested.emit();
  };

  public constructor(public readonly flowFacade: CueExportFlowFacade) {}

  public get closeButtonLabel(): string {
    return this.importResult?.statusCode ? 'Cerrar ventana' : 'Cancelar sin enviar';
  }

  public get importResult(): CueMessagePayload | null {
    return this.flowFacade.importResult;
  }

  public get messageState(): CueMessageState {
    return this.flowFacade.messageState;
  }

  public get sendButtonLabel(): string {
    return CueStatusPresenter.sendButtonLabel(this.flowFacade.statusCue);
  }

  public get showSpinner(): boolean {
    return this.flowFacade.showSpinner;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && !this.visible) {
      this.flowFacade.close();
      return;
    }

    if ((changes['visible'] || changes['finca']) && this.visible && this.finca?.id) {
      this.historyReviewFilter = 'all';
      this.flowFacade.reset();
      this.flowFacade.checkStatus(this.finca, this.emitRefreshRequested);
    }
  }

  public canSendCue(): boolean {
    return this.flowFacade.canSendCue();
  }

  public close(): void {
    this.flowFacade.close();
    this.visibleChange.emit(false);
  }

  public hasPendingCue(): boolean {
    return this.flowFacade.hasPendingCue();
  }

  public pendingTaskCount(): number {
    return this.flowFacade.pendingTaskCount();
  }

  public retryCorrectedActivities(): void {
    this.historyReviewFilter = 'problems';
    this.send();
  }

  public retryPendingCue(): void {
    if (!this.finca) {
      return;
    }

    this.flowFacade.retryPendingCue(this.finca, this.emitRefreshRequested);
  }

  public send(): void {
    this.flowFacade.send(this.finca, this.emitRefreshRequested);
  }

  public showAcceptedActivities(): void {
    this.historyReviewFilter = 'accepted';
  }

  public showProblemActivities(): void {
    this.historyReviewFilter = 'problems';
  }

  public statusHelp(status?: string | number): string {
    return CueStatusPresenter.statusHelp(status);
  }
}
